import { call, put, takeEvery } from 'redux-saga/effects';
import { getReports } from '../../api/ReportsApi';
import {
  retrieveOutboundReportsSuccessActionCreator,
  retrieveOutboundReportsFailureActionCreator,
} from '../actions/ReportsActions';
import { RETRIEVE_OUTBOUND_REPORTS_REQUEST } from '../actions/types/ReportsActionTypes';

function* retrieveReportsWorker() {
  try {
    const reportsResponse = yield call(getReports);
    yield put(retrieveOutboundReportsSuccessActionCreator(reportsResponse.data));
  } catch (error) {
    yield put(retrieveOutboundReportsFailureActionCreator(error));
  }
}

function* reportsWatcher() {
  yield takeEvery(RETRIEVE_OUTBOUND_REPORTS_REQUEST, retrieveReportsWorker);
}

export default reportsWatcher;
